import api from "./index";

// GET tasks API call
// Params: lead, property, task_type, status, priority, completed, overdue
export const getTasks = (params = {}) =>
  api.get("task-management/tasks/", { params });

// POST create task API call
export const createTask = (taskData) =>
  api.post("task-management/tasks/", taskData);

// PUT update task API call
export const updateTask = (id, taskData) =>
  api.put(`task-management/tasks/${id}/`, taskData);

// DELETE task API call
export const deleteTaskRequest = (id) =>
  api.delete(`task-management/tasks/${id}/`);

// PATCH task completion status
export const toggleTaskCompletion = (id, completed) =>
  api.patch(`task-management/tasks/${id}/`, { completed });

// Get tasks for a specific lead
export const getTasksByLead = (leadId) =>
  api.get("task-management/tasks/", { params: { lead: leadId } });

// Get tasks for a specific property
export const getTasksByProperty = (propertyId) =>
  api.get("task-management/tasks/", { params: { property: propertyId } });
